import React, { useContext } from 'react';
import { CoreContext, Settings } from '../../providers';

interface VisibleOnVersionProps {
    versions: Settings['languageVersion'][];
}

export const VisibleOnVersion: React.FC<VisibleOnVersionProps> = ({
    versions,
    children,
}) => {
    const { settings } = useContext(CoreContext);

    return versions.includes(settings.languageVersion) ? <>{children}</> : null;
};
